import type { FilterData } from '../../../types';

export const getRangeFilterValues = (filterDictionaryEntry: FilterData | undefined) => {
    if (!filterDictionaryEntry) {
        throw new Error('Invalid filter dictionary entry');
    }

    const { minKey, maxKey, minValues, maxValues, label } = filterDictionaryEntry;

    const initialMinValue = minValues[0].value;
    const initialMaxValue = maxValues[0].value;

    if (
        !minKey ||
        !maxKey ||
        initialMinValue === undefined ||
        initialMaxValue === undefined ||
        !Array.isArray(minValues) ||
        !Array.isArray(maxValues)
    ) {
        throw new Error('Invalid filter dictionary entry');
    }

    return {
        minKey,
        maxKey,
        minValues,
        maxValues,
        initialMinValue,
        initialMaxValue,
        label,
    };
};
